import styled from "styled-components";

const Wrapper = styled.section`
    *{
        font-family : 'McKinsey Sans Regular', 'Helvetica Neue', Calibri, sans-serif;
    }
    h1{
        margin : 0;
    }
    >p{
        color : #6c6c6c;
        font-size : 1.2rem;
        margin : 10px 0;
    }
    h1{
        font-weight : 800;
        
        font-size : 2rem;
    }
    h2{
        font-weight : 800;
        font-size : 1.2rem;
    }
    @media screen and (max-width: 1000px) {
        max-width : 100%;
        margin : 0 10px;
        .cards{
            justify-content : center;
        }
    }
    max-width : 90%;
    margin:auto;
    padding : 50px 0;
    .cards{
        flex : 1;
        display : flex;
        flex-wrap : wrap;
        gap : 30px;
        margin-top : 30px;
    }
`

export default Wrapper